import Head from './Head';
import NewsGrid from 'components/NewsGrid';
import PageBody, { ViewName } from 'views/PageBody';
import useTranslate from 'contexts/TranslateContext/useTranslate';
import { Props as GridProps } from 'components/NewsGrid/NewsGrid';
import { NEWS_DIRECTORY_SLUG } from 'state/News/constants';

export type Props = {
  pageResumeParams: Record<string, unknown> | null;
  loadNewsArticles: (
    slug: string,
    topicSlug?: string,
    pageResumeParams?: Record<string, unknown> | null,
  ) => void;
} & GridProps;

export default function NewsDirectory({
  articles,
  hasMoreArticles,
  loadNewsArticles,
  pageResumeParams,
}: Props) {
  const translate = useTranslate();

  return (
    <>
      <Head />
      <PageBody
        dataTest={ViewName.NewsDirectory}
        title={translate(
          `Music & Entertainment News - Follow your favorite artists and bands and keep up on today's pop culture news.`,
        )}
      >
        <NewsGrid
          articles={articles}
          hasMoreArticles={hasMoreArticles}
          loadMore={() =>
            loadNewsArticles(NEWS_DIRECTORY_SLUG, undefined, pageResumeParams)
          }
        />
      </PageBody>
    </>
  );
}
